export default "__VITE_ASSET__28a349ec__"